<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <!--新增/维护 MODAL-->
      <create-form
        ref="createModal"
        @getTableData="_getTableData"
        :checkRoleNameInRange="checkRoleNameInRange"
      />

      <div class="text-right">
        <a-button @click="$refs.createModal.add()" type="primary" icon="plus">
          新增角色
        </a-button>
      </div>
      <TableView
        :loading="loading"
        :scroll="scroll"
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        v-on:handlePagination="handlePagination"
      >
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            @click="$refs.createModal.edit(tableRow)"
          >
            维护
          </a>
          <template v-if="!checkRoleNameInRange(tableRow.name)">
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定要删除吗?"
              @confirm="() => onDelete(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a href="javascript:void(0)" size="small">
                删除
              </a>
            </a-popconfirm>
          </template>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, deleteRole } from './api'
import CreateForm from './components/CreateForm'
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
    CreateForm,
  },
  data() {
    return {
      scroll: { x: 1000 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      loading: false,
      roleNameRange: ['系统管理员', '信用主管', '申请人'],
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 在这些范围内的角色名称不能编辑名称也不能删除
    checkRoleNameInRange(roleName) {
      const range = this.roleNameRange
      if (range.includes(roleName)) {
        return true
      }
      return false
    },
    //获取table数据
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        delete query.times
        delete query.pageSize
        const {
          data: { total, records },
        } = await getTableData(query)
        this.loading = false
        this.tableData = records
        this.pageData.total = total
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.searchData.name = query.name
      if (query.times && query.times[0]) {
        this.searchData.startTime = query.times[0]
        this.searchData.endTime = query.times[1]
      } else {
        this.searchData.startTime = ''
        this.searchData.endTime = ''
      }
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    // 删除table数据
    async onDelete(row) {
      try {
        await deleteRole(row.id)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
